const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

/** Latin digits -> Persian, for anything a user reads. */
export function toFa(value) {
  return String(value == null ? "" : value).replace(/[0-9]/g, (d) => FA_DIGITS[d]);
}

/**
 * Persian (and Arabic-Indic) digits -> Latin.
 *
 * Used before a value leaves the UI — a copied tracking code or phone number has to be
 * in the form you can paste into a form or dial.
 */
export function toEn(value) {
  return String(value == null ? "" : value)
    .replace(/[۰-۹]/g, (d) => String(FA_DIGITS.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String("٠١٢٣٤٥٦٧٨٩".indexOf(d)));
}
